import React, { useState } from "react";

function LoginModal({ onClose }) {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOtpChange = (value, index) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleSendOtp = () => {
    if (phone.length < 10) return;
    setLoading(true);
    setTimeout(() => { setLoading(false); setStep(2); }, 1500);
  };

  const handleVerifyOtp = () => {
    if (otp.join("").length < 4) return;
    setLoading(true);
    setTimeout(() => { setLoading(false); setStep(3); }, 1500);
  };

  const handleComplete = () => {
    if (!name) return;
    setLoading(true);
    setTimeout(() => { setLoading(false); setStep(4); }, 1500);
  };

  return (
    <div style={{position:"fixed", top:0, left:0, width:"100%", height:"100%", background:"rgba(0,0,0,0.75)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:2000, backdropFilter:"blur(6px)"}}>
      <div style={{background:"#fff", borderRadius:"24px", padding:"40px", width:"420px", position:"relative", boxShadow:"0 24px 64px rgba(0,0,0,0.2)"}}>
        <button onClick={onClose} style={{position:"absolute", top:"16px", right:"16px", background:"#f1f5f9", border:"none", color:"#374151", fontSize:"16px", cursor:"pointer", width:"32px", height:"32px", borderRadius:"999px"}}>✕</button>

        {/* Progress bar */}
        {step < 4 && (
          <div style={{marginBottom:"28px"}}>
            <div style={{display:"flex", justifyContent:"space-between", marginBottom:"8px"}}>
              {["Phone", "OTP", "Profile"].map((label, i) => (
                <div key={i} style={{display:"flex", flexDirection:"column", alignItems:"center", gap:"4px"}}>
                  <div style={{width:"28px", height:"28px", borderRadius:"999px", background: step > i ? "linear-gradient(135deg, #0d9488, #0891b2)" : step === i + 1 ? "linear-gradient(135deg, #0d9488, #0891b2)" : "#e2e8f0", display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontSize:"12px", fontWeight:"700"}}>
                    {step > i + 1 ? "✓" : i + 1}
                  </div>
                  <span style={{fontSize:"11px", color: step >= i + 1 ? "#0d9488" : "#94a3b8", fontWeight:"600"}}>{label}</span>
                </div>
              ))}
            </div>
            <div style={{height:"4px", background:"#e2e8f0", borderRadius:"999px"}}>
              <div style={{height:"4px", background:"linear-gradient(135deg, #0d9488, #0891b2)", borderRadius:"999px", width: step === 1 ? "0%" : step === 2 ? "50%" : "100%", transition:"width 0.4s ease"}} />
            </div>
          </div>
        )}

        {/* Step 1 — Phone */}
        {step === 1 && (
          <>
            <div style={{textAlign:"center", marginBottom:"28px"}}>
              <div style={{fontSize:"40px", marginBottom:"8px"}}>📱</div>
              <h2 style={{fontSize:"22px", fontWeight:"900", color:"#0f172a", marginBottom:"6px"}}>Welcome to Sajilo Policy</h2>
              <p style={{fontSize:"14px", color:"#64748b"}}>Enter your mobile number to get started</p>
            </div>
            <label style={{fontSize:"13px", fontWeight:"700", color:"#374151", display:"block", marginBottom:"6px"}}>Mobile Number</label>
            <div style={{display:"flex", gap:"8px", marginBottom:"20px"}}>
              <div style={{background:"#f8fafc", border:"1.5px solid #e2e8f0", borderRadius:"10px", padding:"12px 14px", fontSize:"14px", color:"#374151", fontWeight:"600", whiteSpace:"nowrap"}}>🇳🇵 +977</div>
              <input
                value={phone}
                onChange={e => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
                placeholder="98XXXXXXXX"
                type="tel"
                style={{flex:1, padding:"12px", borderRadius:"10px", border:"1.5px solid #e2e8f0", background:"#f8fafc", color:"#0f172a", fontSize:"14px", outline:"none", boxSizing:"border-box"}} />
            </div>
            <button onClick={handleSendOtp} disabled={phone.length < 10 || loading}
              style={{width:"100%", background: phone.length < 10 ? "#e2e8f0" : "linear-gradient(135deg, #0d9488, #0891b2)", color: phone.length < 10 ? "#94a3b8" : "#fff", border:"none", borderRadius:"12px", padding:"14px", fontWeight:"700", fontSize:"16px", cursor: phone.length < 10 ? "not-allowed" : "pointer", transition:"all 0.2s"}}>
              {loading ? "Sending OTP..." : "Send OTP →"}
            </button>
            <p style={{textAlign:"center", fontSize:"12px", color:"#94a3b8", marginTop:"16px"}}>By continuing, you agree to our Terms & Privacy Policy</p>
          </>
        )}

        {/* Step 2 — OTP */}
        {step === 2 && (
          <>
            <div style={{textAlign:"center", marginBottom:"28px"}}>
              <div style={{fontSize:"40px", marginBottom:"8px"}}>🔐</div>
              <h2 style={{fontSize:"22px", fontWeight:"900", color:"#0f172a", marginBottom:"6px"}}>Enter OTP</h2>
              <p style={{fontSize:"14px", color:"#64748b"}}>We sent a 4-digit code to <strong>+977 {phone}</strong></p>
            </div>
            <div style={{display:"flex", gap:"12px", justifyContent:"center", marginBottom:"24px"}}>
              {otp.map((digit, i) => (
                <input
                  key={i}
                  id={`otp-${i}`}
                  value={digit}
                  onChange={e => handleOtpChange(e.target.value, i)}
                  onKeyDown={e => { if (e.key === "Backspace" && !digit && i > 0) document.getElementById(`otp-${i-1}`).focus(); }}
                  maxLength={1}
                  style={{width:"56px", height:"56px", textAlign:"center", fontSize:"24px", fontWeight:"800", borderRadius:"12px", border: digit ? "2px solid #0d9488" : "2px solid #e2e8f0", background:"#f8fafc", color:"#0f172a", outline:"none"}} />
              ))}
            </div>
            <button onClick={handleVerifyOtp} disabled={otp.join("").length < 4 || loading}
              style={{width:"100%", background: otp.join("").length < 4 ? "#e2e8f0" : "linear-gradient(135deg, #0d9488, #0891b2)", color: otp.join("").length < 4 ? "#94a3b8" : "#fff", border:"none", borderRadius:"12px", padding:"14px", fontWeight:"700", fontSize:"16px", cursor: otp.join("").length < 4 ? "not-allowed" : "pointer"}}>
              {loading ? "Verifying..." : "Verify OTP →"}
            </button>
            <p style={{textAlign:"center", fontSize:"13px", color:"#64748b", marginTop:"16px"}}>
              Didn't receive it?{" "}
              <span onClick={() => setStep(1)} style={{color:"#0d9488", fontWeight:"700", cursor:"pointer"}}>Resend OTP</span>
            </p>
          </>
        )}

        {/* Step 3 — Name & Email */}
        {step === 3 && (
          <>
            <div style={{textAlign:"center", marginBottom:"28px"}}>
              <div style={{fontSize:"40px", marginBottom:"8px"}}>👤</div>
              <h2 style={{fontSize:"22px", fontWeight:"900", color:"#0f172a", marginBottom:"6px"}}>Almost there!</h2>
              <p style={{fontSize:"14px", color:"#64748b"}}>Tell us a little about yourself</p>
            </div>
            <div style={{display:"flex", flexDirection:"column", gap:"16px", marginBottom:"24px"}}>
              <div>
                <label style={{fontSize:"13px", fontWeight:"700", color:"#374151", display:"block", marginBottom:"6px"}}>Full Name *</label>
                <input value={name} onChange={e => setName(e.target.value)} placeholder="Ram Bahadur Thapa"
                  style={{width:"100%", padding:"12px", borderRadius:"10px", border:"1.5px solid #e2e8f0", background:"#f8fafc", color:"#0f172a", fontSize:"14px", outline:"none", boxSizing:"border-box"}} />
              </div>
              <div>
                <label style={{fontSize:"13px", fontWeight:"700", color:"#374151", display:"block", marginBottom:"6px"}}>Email Address <span style={{color:"#94a3b8", fontWeight:"400"}}>(optional)</span></label>
                <input value={email} onChange={e => setEmail(e.target.value)} placeholder="ram@example.com" type="email"
                  style={{width:"100%", padding:"12px", borderRadius:"10px", border:"1.5px solid #e2e8f0", background:"#f8fafc", color:"#0f172a", fontSize:"14px", outline:"none", boxSizing:"border-box"}} />
              </div>
            </div>
            <button onClick={handleComplete} disabled={!name || loading}
              style={{width:"100%", background: !name ? "#e2e8f0" : "linear-gradient(135deg, #0d9488, #0891b2)", color: !name ? "#94a3b8" : "#fff", border:"none", borderRadius:"12px", padding:"14px", fontWeight:"700", fontSize:"16px", cursor: !name ? "not-allowed" : "pointer"}}>
              {loading ? "Setting up..." : "Complete Setup →"}
            </button>
          </>
        )}

        {/* Step 4 — Success */}
        {step === 4 && (
          <div style={{textAlign:"center", padding:"20px 0"}}>
            <div style={{fontSize:"72px", marginBottom:"16px"}}>🎉</div>
            <h2 style={{fontSize:"26px", fontWeight:"900", color:"#0f172a", marginBottom:"8px"}}>Welcome, {name}!</h2>
            <p style={{color:"#64748b", fontSize:"15px", marginBottom:"8px"}}>You're all set on Sajilo Policy.</p>
            <p style={{color:"#64748b", fontSize:"14px", marginBottom:"28px"}}>Browse our plans and get covered in minutes 🛡️</p>
            <button onClick={onClose}
              style={{background:"linear-gradient(135deg, #0d9488, #0891b2)", color:"#fff", border:"none", borderRadius:"12px", padding:"14px 40px", fontWeight:"700", fontSize:"15px", cursor:"pointer"}}>
              Browse Plans →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default LoginModal;